export default "__VITE_ASSET__8e0a50cd__"